import React from 'react'
import Home from './components/home'
import Quiz from './components/quiz'
import End from './components/end'

import './styles.css'

class App extends React.Component{
    constructor(props){
        super(props)

        this.state = {
            qStatus: "home",
            qInfos: [],
        }
    }

    render(){
        const { qStatus, qInfos } = this.state

        switch(qStatus){
            case "home":
                return <Home setStatus={(a) => this.setState({qStatus: a})} />
                break;
            case "quiz":
                return (<Quiz infos={(a) => this.setState({qInfos: a})} setStatus={(a) => this.setState({qStatus: a})} />)            
                break;
            case "end"://firework if less than 14 errors
                return (<End infos={qInfos} />)
                break;
            default:
                return (<p>default</p>)
                break;
            
        }
        
    }

}
export default App


// WEBPACK FOOTER //
// ./src/app.js